import { EmployeeLogTypes } from "../../enums/employee-log-type.enum";

export class AddOrEditEmployeeLogModel {
  public id: string;
  public venueEmployeeId: string;
  public employeeLogTypeId: EmployeeLogTypes;
  public from: string;
  public to: string;
  public dateTime: string;
  public venueId: string;
}
